import { useTranslation } from "react-i18next";
import packageIcon from "../../../../Media/Images/Icons/package.webp";
import InputCard from "../../../../GlobalComponents/InputCard";
import ProgressBar from "../../../../GlobalComponents/ProgressBar";
import Textarea from "../../../../GlobalComponents/Textarea";
import Button from "../../../../GlobalComponents/Button";

const BulkPriceEditProgress = ({ processingItems, OnClose }) => {
    const { t } = useTranslation();

    // Count items in processingItems that have a defined status
    const processed = Array.isArray(processingItems) ? processingItems.filter((item) => item.status !== undefined && item.status !== null).length : 0;

    return (
        <>
            <InputCard title={t("BulkEditProccessProgress")} icon={packageIcon} className={"form-group flex-1"} noBodyPadding={false}>
                <ProgressBar processed={processed} total={processingItems?.length} />
                <div className="form-group">
                    <label className="label">{t("BulkEditProccessProgressOutput")}</label>
                    <div
                        style={{
                            width: "100%",
                            minHeight: "120px",
                            maxHeight: "240px",
                            resize: "none",
                            overflowY: "auto",
                            background: "#f8f9fa",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "8px",
                            fontFamily: "monospace",
                            fontSize: "14px",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        {processingItems
                            ?.filter((item) => item.status !== undefined && item.status !== null)
                            .slice() // create a shallow copy
                            .reverse() // reverse the array
                            .map((item, idx) => {
                                let text = "";
                                if (item.status === "success") {
                                    text = `${item?.data?.[0].value} ${item?.data?.[1].value ? `(${item.data[1].value})` : ``} - ${t("Success")}`;
                                } else if (item.status === "error") {
                                    text = `${item?.data?.[0].value} - ${t("Error")}: ${item.errorMessage}`;
                                }
                                return (
                                    <div
                                        key={idx}
                                        style={{
                                            color: item.status === "success" ? "#007bff" : item.status === "error" ? "#dc3545" : "inherit",
                                            marginBottom: "8px",
                                            paddingBottom: "8px",
                                            borderBottom: "1px solid #e0e0e0",
                                        }}
                                    >
                                        {text}
                                    </div>
                                );
                            })}
                    </div>
                </div>

                <div className="form-group">
                    {processed === processingItems?.length && (
                        <Button
                            className="btn-primary narrow"
                            OnClick={() => {
                                OnClose();
                            }}
                            style={{
                                width: "100%",
                                marginTop: "1rem",
                            }}
                        >
                            {t("Close")}
                        </Button>
                    )}
                </div>
            </InputCard>
        </>
    );
};

export default BulkPriceEditProgress;
